import { Duration } from 'luxon';
import { z } from 'zod';
import { TokensResponseSchema, } from '@lucidlink/dto/web-service-api';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- value used only in a type position (z.infer/typeof); v8 no-unused-vars no longer counts type-only usage
const TokenSchema = TokensResponseSchema.extend({
    issuedAt: z.number(), // Unix epoch time
});
const secondToMilliseconds = (seconds) => seconds * 1000;
export class TokenPair {
    tokens;
    constructor(tokens) {
        this.tokens = tokens;
    }
    static fromResponseDto(tokens) {
        return new TokenPair({
            ...tokens,
            issuedAt: Date.now(),
        });
    }
    static fromStorage(storedTokens) {
        return new TokenPair(storedTokens);
    }
    get hasExpired() {
        return (this.tokens.issuedAt +
            secondToMilliseconds(this.tokens.accessTokenTtl) -
            ACCESS_TOKEN_EXPIRATION_TIME_BUFFER <
            Date.now());
    }
    get isAboutToExpire() {
        return (this.tokens.issuedAt +
            secondToMilliseconds(this.tokens.accessTokenTtl) -
            ACCESS_TOKEN_REFRESH_TIME_BUFFER <
            Date.now());
    }
    get hasRefreshTokenExpired() {
        return (this.tokens.issuedAt +
            secondToMilliseconds(this.tokens.refreshTokenTtl) -
            REFRESH_TOKEN_EXPIRATION_TIME_BUFFER <
            Date.now());
    }
    toRawTokens() {
        return this.tokens;
    }
}
const ACCESS_TOKEN_EXPIRATION_TIME_BUFFER = Duration.fromObject({
    second: 15,
}).as('milliseconds');
const ACCESS_TOKEN_REFRESH_TIME_BUFFER = Duration.fromObject({ minute: 1 }).as('milliseconds');
const REFRESH_TOKEN_EXPIRATION_TIME_BUFFER = Duration.fromObject({
    hours: 1,
}).as('milliseconds');
